<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const productsOptions = [
        `Fenêtres aluminium`,
        `Portes coulissantes`,
        `Baies vitrées`,
        `Cloisons de bureau`,
        `Garde-corps`,
        `Murs rideaux`,
        `Véranda`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const projectTypeOptions = [
        `Construction neuve`,
        `Rénovation`,
        `Aménagement intérieur`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const customizationLevelOptions = [
        `Standard`,
        `Sur-mesure`,
        `Je ne suis pas sûr`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.menuiserieAluminium.products}
        class=""
        let:field
        let:id
        label={`Quels produits ou services recherchez-vous ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={productsOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.menuiserieAluminium.projectType}
        class=""
        let:field
        let:id
        label={`Quel type de projet souhaitez-vous réaliser ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={projectTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.menuiserieAluminium.customizationLevel}
        class=""
        let:field
        let:id
        label={`Quel est le niveau de personnalisation souhaité pour votre projet ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={customizationLevelOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
